import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

const EditBank = () => {
  return (
    <div className="income-type-container">
      <div className="top-header-section" style={{ height: "55px" }}>
        <h1 className="page-title-text">Update Bank Details</h1>
      </div>

      <div className="bg-white rounded p-2">
        <Form>
          <Row className="g-3  mt-2">
            {/* Account Holder */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Account Holder <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" placeholder="Enter account holder" />
              </Form.Group>
              {/* <small className="text-danger">
                Account Holder cannot be blank.
              </small> */}
            </Col>

            {/* Account Number */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Account Number <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" placeholder="Enter account number" />
              </Form.Group>
              {/* <small className="text-danger">
                Account Number cannot be blank.
              </small> */}
            </Col>

            {/* Bank Name */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Bank Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" placeholder="Enter bank name" />
              </Form.Group>
              {/* <small className="text-danger">Bank Name cannot be blank.</small> */}
            </Col>

            {/* Swift Code / IBAN / IFSC */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Swift Code / IBAN / IFSC{" "}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" placeholder="Enter code" />
              </Form.Group>
              {/* <small className="text-danger">
                Swift Code/IBAN/IFSC cannot be blank.
              </small> */}
            </Col>

            {/* Branch */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>Branch</Form.Label>
                <Form.Control type="text" placeholder="Enter branch" />
              </Form.Group>
            </Col>
          </Row>

          {/* Create Button */}
          <div className="mt-3 d-flex justify-content-end">
            <Button
              type="submit"
              style={{ backgroundColor: "#5db2e8", border: "none", marginRight: "10px" }}
            >
              Update
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default EditBank;
